// @flow

import * as React from 'react';
import { localize } from '@ta/common.i18n';
import SectionTitle from '../SectionTitle';
import PickerSection from '../PickerSection';
import type { SimpleLink } from '../SimpleLinkSection';
import SimpleLinkSection from '../SimpleLinkSection';
import ExploreLinksSection from '../ExploreLinksSection';
import type { FooterData } from '../daodao-footer';
import styles from './DaoDaoLayout.less';
import LogoLegalSection from '../LogoLegalSection';

export type DDFooterData = {
  links: {
    appLinks: SimpleLink[],
    footerLinks: SimpleLink[],
  },
  icpUrl: string,
  recordFilingUrl: string,
  recordFilingIcon: string,
};

type Props = {
  footerData: FooterData,
  daodaoFooterData: DDFooterData,
};

/**
 * Single unified layout for all DaoDao footers
 */
const DaoDaoLayout = ({ footerData, daodaoFooterData }: Props) => (
  <div className={styles.footerContainer}>
    <div className="ui_container">
      <div className="ui_columns is-multiline is-mobile">
        <div className={`ui_column ${styles.bottomOnMobile} is-9-tablet is-12-mobile`}>
          <LogoLegalSection
            legalData={footerData.legal}
            icpUrl={daodaoFooterData.icpUrl}
            recordFilingUrl={daodaoFooterData.recordFilingUrl}
            recordFilingIcon={daodaoFooterData.recordFilingIcon}
            footerLinks={daodaoFooterData.links.footerLinks}
          />
        </div>

        <div className="ui_column is-6-mobile is-hidden-tablet">
          <div className={styles.footerSection}>
            <SectionTitle text={localize('footer_explore')} />
            <ExploreLinksSection links={footerData.links.exploreLinks} />
          </div>
        </div>

        <div className="ui_column is-6-mobile is-hidden-tablet">
          <div className={styles.footerSection}>
            <SectionTitle text={localize('footer_get_app')} />
            <SimpleLinkSection links={daodaoFooterData.links.appLinks} />
          </div>
        </div>

        <div className={`ui_column ${styles.topOnMobile} is-3-tablet is-12-mobile`}>
          <div className={`${styles.footerSection} ${styles.sectionWithBorderSeparatorMobileOnly}`}>
            <SectionTitle text={localize('footer_currency_country')} />
            <PickerSection
              currencyPreview={footerData.currencyPreview}
              posPreview={footerData.posPreview}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default DaoDaoLayout;
